module.exports = __webpack_public_path__ + "static/media/mainCover.8ef6e805.jpg";